"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactHelmetAsync = require("react-helmet-async");

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _core = require("@material-ui/core");

var _excluded = ["Component", "dataQa", "className", "color"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GOOGLE_FONTS_URL = 'https://fonts.googleapis.com/css?family=Lato:400,400i,900,900i&display=swap';
var materialColors = ['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary'];

var styles = function styles(theme) {
  return {
    colorPrimaryContrastText: {
      color: theme.palette.primary.contrastText
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/**
 * Passthrough component from Material UI Typography:
 * https://material-ui.com/api/typography/
 */

var Typography = function Typography(_ref) {
  var Component = _ref.Component,
      dataQa = _ref.dataQa,
      className = _ref.className,
      color = _ref.color,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  var customColor = !materialColors.includes(color);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react["default"].createElement("link", {
    href: GOOGLE_FONTS_URL,
    rel: "stylesheet"
  })), /*#__PURE__*/_react["default"].createElement(_core.Typography, (0, _extends2["default"])({
    "data-qa": dataQa,
    color: customColor ? undefined : color,
    className: (0, _classnames["default"])(className, (0, _defineProperty2["default"])({}, classes.colorPrimaryContrastText, color === 'primaryContrastText'))
  }, props, {
    component: Component
  })));
};

Typography.propTypes = {
  /** Selector for QA */
  dataQa: _propTypes["default"].string,

  /** Text colors available, as defined by theme palette */
  color: _propTypes["default"].oneOf([].concat(materialColors, ['primaryContrastText']))
};
var _default = Typography;
exports["default"] = _default;